import { createContext, useState } from "react";
import Cookies from 'js-cookie'

const AuthContext = createContext({})

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState({})
    const [email, setEmail] = useState('')
    const [isLoggedIn, setIsLoggedIn] = useState(false)

    const login = () => {
        setIsLoggedIn(true)
        Cookies.set('isLoggedIn', true)
    }

    const logout = () => {
        setIsLoggedIn(false)
        Cookies.remove('isLoggedIn')
    }

    return (
        <AuthContext.Provider value={{ 
            auth, 
            setAuth, 
            email, 
            setEmail,
            isLoggedIn,
            login,
            logout
        }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext;